var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M11.5,15 L12.5,15 C12.7761424,15 13,15.2238576 13,15.5 L13,16.5 C13,16.7761424 12.7761424,17 12.5,17 L11.5,17 C11.2238576,17 11,16.7761424 11,16.5 L11,15.5 C11,15.2238576 11.2238576,15 11.5,15 Z M11.5,7 L12.5,7 C12.7761424,7 13,7.22385763 13,7.5 L13,12.5 C13,12.7761424 12.7761424,13 12.5,13 L11.5,13 C11.2238576,13 11,12.7761424 11,12.5 L11,7.5 C11,7.22385763 11.2238576,7 11.5,7 Z M2,12 C2,17.52 6.47,22 11.99,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 11.99,2 C6.47,2 2,6.48 2,12 Z M4,12 C4,7.58 7.58,4 12,4 C16.42,4 20,7.58 20,12 C20,16.42 16.42,20 12,20 C7.58,20 4,16.42 4,12 Z"}));
}

Info.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Info;

Info.default = Info;
